import React, { useEffect } from "react";
import { Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import { useProgectsDomainByIdQuery } from "../../../graphql/projects.hooks";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import EditProjectInfo from "./EditProjectInfo";
import { useUserQuery } from "../../../graphql/menu.hooks";
import { CustomToast } from "../../../components/inputs/toast";
import { useReactiveVar } from "@apollo/client";
import { isSavedChanges } from "../../../graphql/state";

export default function EditProject() {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const isShowToast = useReactiveVar(isSavedChanges);
  const { projectId } = useParams();
  const { data: User } = useUserQuery();
  const currentUser = User?.user?.email;

  const { data, loading } = useProgectsDomainByIdQuery({
    variables: { domainId: Number(projectId) },
  });

  useEffect(() => {
    document.title = "Edit Project";
  }, []);

  const location = useLocation();
  const sharedValue = location.state?.shared;
  const accessType = data?.domain?.userAccesses?.find(
    (user) => user?.user?.email === currentUser
  );
  const link = sharedValue || accessType ? `${lng}/shared` : `${lng}/projects`;

  return (
    <div className="px-lg-3">
      <h1 className="fs-1 fw-bold">{t("projects.Project Settings")}</h1>
      <div className="text-gray mb-4 mb-md-5">
        <Link to={link}>
          {sharedValue || accessType ? t("menu.shared") : t("payment.Projects")}
        </Link>
        <span className="px-2">/</span>
        {loading ? (
          <Spinner
            animation="border"
            role="status"
            size="sm"
            className="ms-2"
          />
        ) : (
          <Link to={`${lng}/projects/${projectId}`}>{data?.domain?.title}</Link>
        )}
        <span className="px-2">/</span>
        {t("projects.Project Settings")}
      </div>

      <div className="text-dark bg-white p-3 py-4 p-md-5 rounded">
        <Col lg={11} className="m-auto px-lg-4">
          {loading ? (
            <div className="text-center my-5 py-5">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <EditProjectInfo data={data} />
          )}
        </Col>
      </div>
      <CustomToast
        isShow={isShowToast}
        setShow={() => isSavedChanges(false)}
        message={`${t("projects.Changes Saved")}`}
      />
    </div>
  );
}
